{
  "documentType": {
    "planning": "planering",
    "event": "händelse",
    "assignment": "uppdrag",
    "article": "artikel",
    "flash": "flash",
    "quickArticle": "två på två",
    "factbox": "Faktaruta"
  },
  "labels": {
    "newsvalue": "Nyhetsvärde",
    "section": "Sektion",
    "assignee": "Uppdragstagare",
    "assignmentType": "Typ",
    "title": "Titel",
    "time": "Tid",
    "status": "Status",
    "type": "Typ",
    "organiser": "Organisatör",
    "category": "Kategori",
    "action": "Action",
    "story": "Story",
    "showOlder": "Visa äldre",
    "slugline": "Slugg"
  },
  "status": {
    "draft": "Utkast",
    "created": "Skapad",
    "internal": "Intern",
    "approved": "Godkänd",
    "usable": "Publicerad",
    "unpublished": "Avpublicerad",
    "done": "Klar",
    "used": "Använd",
    "print_done": "Klar",
    "needs_proofreading": "Klar för korr",
    "withheld": "Schemalagd",
    "cancelled": "Kastad",
    "changed": "Ändrad",
    "moved": "flyttad",
    "todo": "Att göra",
    "started": "Påbörjad",
    "public": "Publik",
    "sent": "Skickad",
    "typeApproved": "{{type, capitalize}} godkänd",
    "typeDone": "{{type, capitalize}} klar",
    "typeSaved": "{{type, capitalize}} sparad",
    "typeSent": "{{type, capitalize}} skickad",
    "typePublished": "{{type, capitalize}} publicerad"
  },
  "timeSlots": {
    "morning": "Morgon",
    "forenoon": "Förmiddag",
    "afternoon": "Eftermiddag",
    "evening": "Kväll",
    "fullday": "Heldag"
  }
}
